{
  "name": "@kerberos-compliance/aml-desk",
  "version": "26.10.12-stage+6a52548",
  "type": "module",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ng serve --configuration local",
    "start:portless": "portless aml-desk ng serve",
    "start:portless:https": "portless aml-desk ng serve --https",
    "start:clean": "rimraf -rf .angular && rimraf -rf node_modules/.cache && ng serve",
    "start:clean:install": "rimraf .angular && rimraf node_modules/.cache && pnpm i && ng serve",
    "start:clean:install:local": "rimraf .angular && rimraf node_modules/.cache && pnpm i && ng serve --configuration local",
    "start:dev": "npm run build:lib && ng serve --configuration local",
    "watch": "ng build --watch --configuration development",
    "watch:lib": "cd ../../Libraries/compliance-shared-ui && npm run build --watch",
    "build:lib": "cd ../../Libraries/compliance-shared-ui && npm run build",
    "dev": "npm-run-all --parallel watch:lib start:dev",
    "test": "ng test --output-file=coverage/junit.xml",
    "test:watch": "ng test --watch --output-file=coverage/junit.xml",
    "test:coverage": "ng test --coverage --output-file=coverage/junit.xml",
    "test:ci": "ng test --coverage --output-file=coverage/junit.xml",
    "build:ci": "cross-env NODE_ENV=$ANGULAR_CONFIGURATION ng build --configuration $ANGULAR_CONFIGURATION",
    "build:dev": "ng build --output-hashing all --configuration development",
    "verify:no-dx": "node scripts/assert-no-dx-in-production.js",
    "verify:no-dx:build": "ng build --configuration production && node scripts/assert-no-dx-in-production.js",
    "analyze": "ng build --configuration production --stats-json && open https://esbuild.github.io/analyze/",
    "prettier-all": "prettier --config .prettierrc.json --ignore-path .prettierignore --write '**/*.{js,ts,json,html,css,scss,md}'",
    "lint": "npx eslint src",
    "type:check": "tsc --noEmit",
    "e2e": "ng e2e",
    "e2e:dev": "playwright test --reporter=list",
    "e2e:demo": "playwright test --reporter=list --config=playwright.demonstration.config.ts",
    "docs:json": "compodoc -p ./tsconfig.json -e json -d .",
    "storybook": "ng run cop-app:storybook",
    "build-storybook": "ng run cop-app:build-storybook",
    "prepare": "husky",
    "migration:find": "node scripts/find-migration-candidates.js",
    "migration:find:behaviorsubject": "node scripts/find-migration-candidates.js --type behaviorsubject",
    "migration:find:subject": "node scripts/find-migration-candidates.js --type subject",
    "migration:find:input-output": "node scripts/find-migration-candidates.js --type input-output",
    "migration:report": "node scripts/find-migration-candidates.js --output migration-report.txt && cat migration-report.txt",
    "migration:report:json": "node scripts/find-migration-candidates.js --json --output migration-report.json",
    "generate:store": "node scripts/generate-signal-store.js",
    "i18n:report": "node scripts/analyze-translations.js --report",
    "i18n:check": "node scripts/analyze-translations.js --report --verbose",
    "i18n:dry-run": "node scripts/analyze-translations.js --dry-run",
    "i18n:clean": "node scripts/analyze-translations.js --clean",
    "i18n:align": "node scripts/analyze-translations.js --align",
    "i18n:sync": "node scripts/analyze-translations.js --sync",
    "update-deps": "ncu --cooldown 3 --interactive --packageManager pnpm && pnpm audit --fix=override"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "22.2.0",
    "@angular/common": "22.2.0",
    "@angular/compiler": "22.2.0",
    "@angular/core": "22.2.0",
    "@angular/forms": "22.2.0",
    "@angular/platform-browser": "22.2.0",
    "@angular/platform-browser-dynamic": "22.2.0",
    "@angular/router": "22.2.0",
    "@bluehalo/ngx-leaflet": "22.0.0",
    "@e965/xlsx": "0.20.3",
    "@jsverse/transloco": "8.4.0",
    "@kerberos-compliance/compliance-shared-ts": "26.10.5",
    "@kerberos-compliance/compliance-shared-ui": "26.10.1",
    "@ngx-formly/core": "8.0.0",
    "@ngx-formly/ng-zorro-antd": "8.0.0",
    "@sentry/angular": "10.75.0",
    "@sentry/core": "10.75.0",
    "@teamhanko/hanko-frontend-sdk": "2.7.0",
    "class-transformer": "0.5.1",
    "class-validator": "0.15.1",
    "dayjs": "1.11.23",
    "dotenv": "17.4.2",
    "echarts": "6.1.0",
    "file-type": "22.1.1",
    "i18n-iso-countries": "7.14.0",
    "jwt-decode": "4.0.0",
    "klaro": "0.7.22",
    "leaflet": "1.9.4",
    "lodash-es": "4.18.1",
    "ng-zorro-antd": "22.1.1",
    "ngx-echarts": "22.0.0",
    "reflect-metadata": "0.2.2",
    "rimraf": "6.1.3",
    "rxjs": "7.8.2",
    "socket.io-client": "4.8.3",
    "ts-node": "10.9.2",
    "tslib": "2.8.1"
  },
  "devDependencies": {
    "@angular-builders/custom-webpack": "22.0.1",
    "@angular-devkit/architect": "0.2202.0",
    "@angular-devkit/build-angular": "22.2.0",
    "@angular-eslint/builder": "22.5.0",
    "@angular/build": "22.2.0",
    "@angular/cli": "22.2.0",
    "@angular/compiler-cli": "22.2.0",
    "@angular/elements": "22.2.0",
    "@babel/core": "7.29.0",
    "@commitlint/cli": "21.2.2",
    "@commitlint/config-conventional": "21.2.2",
    "@compodoc/compodoc": "2.0.0",
    "@kerberos-compliance/tools-configs-ts": "26.9.0",
    "@playwright/test": "1.63.0",
    "@storybook/addon-docs": "10.6.0",
    "@storybook/addon-links": "10.6.0",
    "@storybook/angular": "10.6.0",
    "@types/leaflet": "1.9.21",
    "@types/node": "25.9.8",
    "@typescript-eslint/eslint-plugin": "8.69.0",
    "@typescript-eslint/parser": "8.69.0",
    "@vitest/coverage-v8": "5.0.0",
    "@vitest/ui": "5.0.0",
    "@webcomponents/custom-elements": "1.6.0",
    "autoprefixer": "10.5.0",
    "babel-loader": "10.1.1",
    "compression-webpack-plugin": "12.0.0",
    "cross-env": "10.1.0",
    "eslint": "10.9.1",
    "eslint-import-resolver-node": "0.4.0",
    "eslint-import-resolver-typescript": "4.4.5",
    "eslint-interactive": "14.0.0",
    "eslint-plugin-storybook": "10.6.0",
    "fuzzy": "0.1.3",
    "husky": "9.1.7",
    "inquirer": "13.4.3",
    "inquirer-autocomplete-prompt": "3.0.1",
    "jsdom": "30.1.0",
    "jsonc-parser": "3.3.1",
    "lint-staged": "17.4.1",
    "ng-mocks": "14.18.1",
    "npm-check-updates": "23.1.0",
    "npm-run-all": "4.1.5",
    "open": "11.0.0",
    "playwright-ng-schematics": "22.1.2",
    "postcss": "8.5.14",
    "prettier": "3.9.6",
    "pretty-quick": "4.2.2",
    "react": "19.2.6",
    "react-dom": "19.2.6",
    "rimraf": "6.1.3",
    "source-map-explorer": "2.5.3",
    "storybook": "10.6.0",
    "storybook-addon-angular-router": "1.10.1",
    "typescript": "6.0.3",
    "vitest": "5.0.0"
  },
  "engines": {
    "node": ">=24.20.0",
    "pnpm": "12.3.3"
  },
  "packageManager": "pnpm@12.3.3"
}